import React from "react";
import classNames from "classnames";

export interface CardHeaderProps {
    title?: string;
    subtitle?: string;
    avatar?: string;
    actions?: string;
    className?: string;
    h4?: boolean;
    h5?: boolean;
    h6?: boolean;
    children?: any;
    [x: string]: any;
}

export const CardHeader = ({
    title,
    subtitle,
    avatar,
    actions,
    className,
    h4,
    h5,
    h6,
    children,
    ...props
}: CardHeaderProps) => {
    if (h4)
        return (
            <h4 className={classNames("card-header", className)} {...props}>
                {children}
            </h4>
        );
    if (h5)
        return (
            <h5 className={classNames("card-header", className)} {...props}>
                {children}
            </h5>
        );
    if (h6)
        return (
            <h6 className={classNames("card-header", className)} {...props}>
                {children}
            </h6>
        );
    return (
        <div className={classNames("card-header", className)} {...props}>
            {title}
            {children}
        </div>
    );
};
